import {createContext, type ReactNode, use} from 'react'

import type {FieldsData} from '../../components/saved-view-options/fields'

const FieldsContext = createContext<FieldsData | null>(null)

/**
 * Shares host-supplied field metadata: identifiers, labels, icons, and capabilities.
 * Does not fetch metadata or own the user's selected configuration.
 */
export function FieldsProvider({data, children}: {data: FieldsData; children: ReactNode}) {
  return <FieldsContext value={data}>{children}</FieldsContext>
}

export function useFields(): FieldsData {
  const data = use(FieldsContext)
  if (data === null) {
    throw new Error('useFields must be used within <FieldsProvider>')
  }
  return data
}
